const formatDate = (date: string) => {
  return date
    .split("-")
    .reverse()
    .filter((el, index) => index !== 2)
    .join(".");
};
export const ListOfDates = ({ list_of_dates }: { list_of_dates: string }) => {
  return (
    <div>
      <div
        className="d-flex"
        style={{ overflow: "scroll",fontSize:0.8 + 'rem' }}
      >
        {list_of_dates.split(",").map((date) => {
          return (
            <div
              key={date}
              className="full-list-of-tags-item full-list-of-tags-item-selected mr-3"
            >
              <div className="full-list-of-tags-item-text">
                {formatDate(date)}
              </div>
            </div>
          );
        })}
        {/* <span className="mr-2" style={{ fontSize: 10 + "px" }}>
        возможны неточности, проверяйти Источник
      </span> */}
      </div>
    </div>
  );
};
